import i18n from '../../../i18n/index'

export default {
  data() {
    return {
      headers: [
        {
          sortable: false,
          text: i18n.t('headers.row-number'),
          value: "plu",
          align: "left"
        },
        {
          sortable: false,
          text: i18n.t('headers.error-description'),
          align: "left"
        }
      ]
    };
  },
  props: {
    fileUpload: {
      type: Object,
      default: () => ({ fileLoadDetails: [] })
    }
  },
  methods: {}
}
